import * as React from 'react';
import { compose, withProps } from 'recompose';
import { skin, OemProps } from 'ui/styles/skin';

export type OwnProps = React.InputHTMLAttributes<HTMLInputElement>;

export const RawInput = ({ styles, ...props }: OwnProps & RecomposeProps & OemProps) =>
    <input
        type="text"
        { ...props }
    />
;

type RecomposeProps = {
    style: {};
};

export const Input = compose<OwnProps & RecomposeProps & OemProps, OwnProps>(
    skin,
    withProps(({ style = {}, styles }: OemProps & OwnProps) => ({
        style: {
            ...styles.Input,
            ...style,
        },
    })),
)(RawInput);



// WEBPACK FOOTER //
// ./src/ui/shared/Input.tsx